import styled from 'styled-components';

interface BaseProps {
	isMobile?: boolean;
}

export const Base = styled.button<BaseProps>`
	background-color: transparent;
	border: none;
	height: 44px;
	width: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 44px;
	min-height: 44px;

	&:hover {
		background-color: ${({ theme }) => theme.gray['200']};
	}

	&:active {
		background-color: ${({ theme }) => theme.gray['200']};
	}
`;
